var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.963,
    height: 13.963,
    viewBox: "0 0 13.963 13.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-information-circle",
    "data-name": "Icon ionic-ios-information-circle",
    d: "M10.357,3.375a6.982,6.982,0,1,0,6.982,6.982A6.981,6.981,0,0,0,10.357,3.375Zm.638,10.2H9.712V8.742h1.282Zm-.641-5.364a.67.67,0,1,1,.695-.671A.673.673,0,0,1,10.353,8.215Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#16346c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.42bbde041915d59a8e4fbcb02d07dfc3.svg";
export { ForwardRef as ReactComponent };